
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
// @ts-ignore
// import draggable from 'vuedraggable';
import BulkEdit from '@/modules/BulkEdit/BulkEdit.vue';
import stores from '@/stores';
import PerPageDropdown from '@/components/PerPageDropdown.vue';
import vPagination from '@/components/VuePlainPagination.vue';
import TvModule , { TvModuleItem } from '@/stores/modules/TvModule';
import Axios from 'axios';
import ListNevronHeader from '@/components/ListNevronComponents/ListNevronHeader.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronEmpty from '@/components/ListNevronComponents/EmptyNevronHeader.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import {sortCheck, sortMoved, sortMove} from '@/helpers/VueDraggableResorting';
import draggable from 'vuedraggable';
import Create from './CreateDynamicModules.vue';

@Component({
  components: {
    BulkEdit,
    draggable,
    ListNevronHeader,
    Skeleton,
    NevronEmpty,
    NevronSearch,
    NevronSearchNoResults,
    PerPageDropdown,
    vPagination,
    Create,
  },
})

export default class ItemsIndex extends Vue {
  @Prop()
  module!: TvModule;

  response: any = null;
  items: TvModuleItem[] = [];

  search: any = {
    query: '',
    current: '',
  };

  sort: any = {
    moved: [],
    changed: [],
    element: 0,
  };

  // TODO
  firstLoad = true;
  perpage = 20;
  indexList: number[] = [];
  allChecked: boolean = false;
  showMain: boolean = true;
  selected: IBulkResponse | null = null;

  file: any = '';
  uploadResponse: any = '';
  exportData: any = '';

  message: any = {
    import: '',
    export: '',
    message: '',
  };

  /*
   * Watch for module
   */
  @Watch('module', { immediate: true })
  setModuleFromProps() {
    this.items = this.module.itemsCollection.models;
    this.module.getData();
  }

  perPageChange() {
    this.fetchData(1);
  }
  @Watch('response.currentPage')
  ChangedPage() {
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    this.search.query = this.search.current;
    this.fetchData(this.response.currentPage, this.search.current);
  }
  /**
   * Called when changes need to re-render
   */
  mounted() {
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }

    // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }

    this.fetchData(index, this.search.query);
  }

  refresh() {
    this.fetchData(this.response.currentPage);
  }

  /*
   * Fetch data
   */
  fetchData(index = 1, search = null) {
    return this.module.fetchData(index, search, this.perpage)
      .then((response) => {
        this.response = response;
        this.items = this.response.data;

        this.search.current = this.search.query;
        this.updateCheck();
      })
      .catch((error) => {
          console.log(error);
      });
  }

  openItem(itemId: string|number) {
    this.$router.push({name: `${this.module.path}.items.show`, params: {id: String(itemId)}, query: {lastpage: String(this.response.currentPage), perpage: String(this.perpage)}});
  }

  /* removes or appends all items ids on current page to indexList */
  checkAll() {
    if (!this.allChecked) {
      this.indexList = Array.from(new Set([...this.indexList, ...this.itemIds]));
      this.allChecked = true;
    } else {
      this.indexList = this.indexList.filter((id) => !this.itemIds.includes(id));
      this.allChecked = false;
    }
  }
  /* when item is checked */
  updateCheck() {
      if (this.itemIds.every((id: number) => this.indexList.includes(id))) {
         this.allChecked = true;
      } else {
         this.allChecked = false;
      }
  }
  get itemIds(): number[] {
    // @ts-ignore
    return this.items.map((item: any) => item.id);
  }

  bulkEdit() {
    return stores.BulkEdit.bulkEdit(this.indexList, this.module.id)
      .then((response: any) => {
        this.showMain = false;
        this.selected = response;
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  @Watch('uploadResponse')
  importCsv() {
    this.module.import(this.uploadResponse, 'series', this.module.id)
      .then((response) => {
        this.message.import = response.result;
        this.message.message = response.message;
        if (response.result === true) {
          this.refresh();
          console.log(response.message);
        } else {
          console.log(response.message);
        }
      });
  }

  exportCSV() {
    this.module.export('series', this.module.id)
      .then((response) => {
        this.exportData = response.data;
        if (response.result === true) {
          const csv = this.exportData;
          const anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          anchor.target = '_blank';
          anchor.download = 'NevronSeriesItems.csv';
          anchor.click();
        }
        this.message.message = response.message;
        this.message.export = response.result;
      });
  }

  importFile(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      this.uploadResponse = e.target ? e.target.result : '';
    };
    reader.readAsText(file);
  }

  toggleActive(item: any) {
    item.active = Number(!item.active);
    this.module.updateItem!(Number(item.id), {id: item.id, active: item.active})
      .then((response) => {
        console.log(response);
      });
  }

  deleteItem(item: any) {
    if (confirm(`Permanently delete "${item.name}"`)) {
      this.module.deleteItem!(Number(item.id)).then((response) => this.fetchData(this.response.currentPage));
    }
  }

}
